import { createEvent } from "library/local-events/index.mjs"

export const DisableNextRegimeStep = createEvent("DisableNextRegimeStep")
